export default __webpack_public_path__ + "static/media/empty.44a915b8.png";